import * as React from 'react';
import {useEffect, useState} from 'react';
import {CenterSpinner, ValidationNotification} from '@soap/baseweb'
import {useAuth} from '@soap/modules'
import {CenteredCard} from "../z40-uicomp/centered-card";
import {Frame} from "../z40-uicomp/frame";
import {LabelMedium, ParagraphMedium} from "baseui/typography";
import {Centered, SpaceAround, SpaceBottom} from "../z40-uicomp/layout";
import {Cell, Grid} from "baseui/layout-grid";
import {useStyletron} from "baseui";
import {Table} from "baseui/table-semantic";
import {TalkBadge} from "../z40-uicomp/talk-badge";
import {LinkButton} from "../z40-uicomp/buttons";
import {useNavigate, useParams} from "react-router";
import {useTour} from '@reactour/tour';
import {useLywTourStorageKey} from '../z70-shadcn/components/lywOnboardingTourSteps';
import robot from "../z30-images/robot-s.png";

export function OrderConfirmation() {

    //* styling 
    const [css, theme] = useStyletron();
    const [planData, setPlanData] = useState();
    const viewStates = {
        loading: 1,
        loaded: 3,
        failed: 4
    };

    const [viewState, setViewState] = useState(viewStates.loading);
    const {id} = useParams();
    const navigate = useNavigate();
    const {setIsOpen, setCurrentStep} = useTour();
    const tourStorageKey = useLywTourStorageKey();
    const {refresh} = useAuth("order-confirmation");

    const startLywTourFromOrder = () => {
        if (typeof window !== 'undefined') {
            window.localStorage.removeItem(tourStorageKey);
        }
        navigate('/app');
        // Same intent as Dashboard Debug Mode "Take the Tour Again", after LYW shell mounts (tour selectors live in AppLayout).
        window.setTimeout(() => {
            setCurrentStep(0);
            setIsOpen(true);
        }, 650);
    };


    useEffect(() => {

        // declare the data fetching function
        const refreshToGetNewPermissions = async () => {
            await refresh({ignoreCache: true});
            setViewState(viewStates.loaded);
        };

        const loadedOnce = sessionStorage.getItem("oc-loaded-once");
        if (viewState === viewStates.loading) {
            if (!loadedOnce) {
                sessionStorage.setItem("oc-loaded-once", "true");
                refreshToGetNewPermissions()
                    // make sure to catch any error
                    .catch(console.error);
            } else {
                setViewState(viewStates.loaded);
            }
        }

        if (viewState === viewStates.loaded) {
            const planJSON = sessionStorage.getItem(id);
            if (!planJSON) {
                setViewState(viewStates.failed);
            }

            if (planJSON) {
                const plan = JSON.parse(planJSON);
                //* convert plan to planData making any adjustments along the way
                const row = plan.tableData.find(x => x[0].startsWith("Tag Limit"));
                const cloned = JSON.parse(JSON.stringify(plan));
                if (row && row[1] === 999) {
                    cloned.tableData.find(x => x[0].startsWith("Tag Limit"))[1] = "Unlimited";
                    setPlanData(cloned);

                } else {
                    setPlanData(cloned);
                }
            }
        }

    }, [refresh, viewState]);

    switch (viewState) {
        case viewStates.failed:
            return (
                <Frame>
                    <CenteredCard>
                        <SpaceAround>
                            <ValidationNotification
                                errorMsg={"An error has occurred confirming your order. Please check your profile or contact support"}/>
                        </SpaceAround>
                    </CenteredCard>
                </Frame>
            );
        case viewStates.loading:
            //* refresh token to pickup any new paid features e.g. organisations
            return <Frame><CenterSpinner/></Frame>;
        case viewStates.loaded:
            return (
                <Frame>
                    <div className="pt-6">
                    <CenteredCard
                        title={<div style={{
                            width: "100%",
                            paddingLeft: "33px"
                        }}>
                            <Centered>Thank You</Centered></div>} showRobot={false}>
                        <SpaceAround>
                            {planData ?
                                <Grid gridMargins={0} gridGaps={5}>
                                    <Cell span={12}>
                                        <><SpaceBottom>
                                            <Centered><LabelMedium>You are now
                                                on {planData.name}!</LabelMedium></Centered></SpaceBottom>
                                        </>
                                        {planData.isNewUser ? (
                                            <SpaceBottom>
                                                <div className="bg-action-blue/10 border border-action-blue/30 rounded-lg p-6 shadow-sm">
                                                    <div className="flex items-start gap-4">
                                                        <img 
                                                            src={robot} 
                                                            width={48} 
                                                            height={48} 
                                                            alt="Learn Your Way Robot"
                                                            className="flex-shrink-0"
                                                        />
                                                        <div className="flex-1 space-y-4">
                                                            <h3 className="text-lg font-semibold text-gray-900 mb-4">
                                                                What's Next?
                                                            </h3>
                                                            <div className="flex flex-col gap-3">
                                                                <button
                                                                    type="button"
                                                                    onClick={startLywTourFromOrder}
                                                                    className="w-full text-left px-4 py-3 bg-white border border-action-blue/40 rounded-md text-action-blue-dark font-medium hover:bg-action-blue/10 hover:border-action-blue/50 transition-colors shadow-sm"
                                                                >
                                                                    Take The Tour
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </SpaceBottom>
                                        ) : null}
                                        <Table columns={planData.tableColumns} data={planData.tableData}/>
                                    </Cell>
                                </Grid> : null}
                        </SpaceAround>
                    </CenteredCard>
                    </div>
                </Frame>
            );
    }
}